import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/payback-period-calculator',
  component: () => import('../../routes/PaybackPeriodCalculator.svelte'),
  card: {
    id: 'payback-period',
    title: 'Payback Period',
    description: 'Calculate how long it takes to recover your initial investment from annual cash flows.',
    icon: 'schedule',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/payback-period-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Payback Period Calculator – Investment Recovery Time',
    description: 'Free payback period calculator. Determine how quickly an investment will pay for itself based on annual cash flows. Includes simple and discounted methods.',
  },
};

export default meta;
